import styled from 'styled-components';

const ViewTitle = styled.header`
  margin: 1rem;
`;

export default ViewTitle;
